import Van from "../../../../../public/van.svg";
import Clock from "../../../../../public/clock.svg";
import App from "../../../../../public/app.svg";

export const items = [
  {
    Icon: Clock,
    text: "24/7/365 Home Maintenance Plan"
  },
  { Icon: App, text: "Thousands of Experts, One App" },
  { Icon: Van, text: "A Dedicated Team" }
];
